(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranivaa-categories"] && !Shopify.designMode) return;
  try {
    
function initRanivaaTabs(root=document){root.querySelectorAll('[data-rv-tabs]').forEach(section=>{if(section.dataset.tabsReady)return;section.dataset.tabsReady='true';const tabs=[...section.querySelectorAll('[role="tab"]')];const panels=[...section.querySelectorAll('[role="tabpanel"]')];function select(i,focus=false){tabs.forEach((tab,n)=>{tab.setAttribute('aria-selected',n===i?'true':'false');tab.tabIndex=n===i?0:-1;panels[n].hidden=n!==i});if(focus)tabs[i].focus()}tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(i));tab.addEventListener('keydown',event=>{let n=i;if(event.key==='ArrowRight')n=(i+1)%tabs.length;else if(event.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;else if(event.key==='Home')n=0;else if(event.key==='End')n=tabs.length-1;else return;event.preventDefault();select(n,true)})});select(0)})}initRanivaaTabs();document.addEventListener('shopify:section:load',e=>initRanivaaTabs(e.target));
function arrangeCategoryHearts(root=document){root.querySelectorAll('.rv-editorial-collection .rv-product-card').forEach(card=>{if(card.dataset.heartReady)return;card.dataset.heartReady='true';const slot=card.querySelector('.rv-card-heart');if(!slot)return;const place=()=>{const widget=card.querySelector('.Vtl-CollectionCardWidget');if(widget&&!slot.contains(widget))slot.appendChild(widget)};place();new MutationObserver(place).observe(card,{childList:true,subtree:true})})}arrangeCategoryHearts();document.addEventListener('shopify:section:load',event=>arrangeCategoryHearts(event.target));
function initRanivaaLoadMore(root=document){
root.querySelectorAll('.rv-editorial-panel').forEach(panel=>{
if(panel.dataset.loadMoreReady)return;
const more=panel.querySelector('[data-rv-load-more]'),less=panel.querySelector('[data-rv-view-less]');
if(!more||!less)return;
panel.dataset.loadMoreReady='true';
const originalUrl=more.href,originalCards=new Set(panel.querySelectorAll('.rv-product-card'));
let busy=false;
more.addEventListener('click',async event=>{
event.preventDefault();if(busy)return;
busy=true;more.setAttribute('aria-disabled','true');
try{
const response=await fetch(more.href);if(!response.ok)throw new Error('Collection unavailable');
const page=new DOMParser().parseFromString(await response.text(),'text/html');
const sourceCards=[...page.querySelectorAll('.rv-collection .rv-product-grid > .rv-product-card')];
if(!sourceCards.length)throw new Error('Products unavailable');
const seen=new Set([...panel.querySelectorAll('.rv-product-card a[href*="/products/"]')].map(link=>new URL(link.href,location.origin).pathname));
sourceCards.forEach(card=>{
const link=card.querySelector('a[href*="/products/"]');if(!link)return;
const path=new URL(link.getAttribute('href'),location.origin).pathname;
if(seen.has(path))return;seen.add(path);
panel.insertBefore(card,panel.querySelector('.rv-category-more'));
});
arrangeCategoryHearts(panel);
const next=page.querySelector('.rv-pagination [data-rv-view-more]');
more.hidden=!next;if(next)more.href=new URL(next.getAttribute('href'),response.url).href;
less.hidden=false;
}catch(error){location.assign(more.href);}
finally{busy=false;more.removeAttribute('aria-disabled');}
});
less.addEventListener('click',()=>{
if(busy)return;
panel.querySelectorAll('.rv-product-card').forEach(card=>{if(!originalCards.has(card))card.remove();});
more.href=originalUrl;more.hidden=false;less.hidden=true;
panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
});
});
}
initRanivaaLoadMore();
document.addEventListener('shopify:section:load',event=>initRanivaaLoadMore(event.target));

if(!window.ranivaaCategoryQuickAdd){
window.ranivaaCategoryQuickAdd=true;
let categoryToastTimer;
const categoryRoot=window.Shopify?.routes?.root||'/';
const showCategoryCartToast=(message,isError=false)=>{
let toast=document.querySelector('.rv-category-cart-toast');
if(!toast){
toast=document.createElement('div');
toast.className='rv-category-cart-toast';
toast.setAttribute('role','status');
toast.setAttribute('aria-live','polite');
toast.innerHTML='<span></span><a href="'+categoryRoot+'cart">View cart</a>';
document.body.appendChild(toast);
}
toast.querySelector('span').textContent=message;
toast.querySelector('a').hidden=isError;
toast.classList.add('is-visible');
clearTimeout(categoryToastTimer);
categoryToastTimer=setTimeout(()=>toast.classList.remove('is-visible'),3200);
};
document.addEventListener('submit',async event=>{
const form=event.target.closest('.rv-editorial-collection form.shopify-product-form');
const button=form?.querySelector('.rv-card-add');
if(!button)return;
event.preventDefault();
event.stopImmediatePropagation();
if(button.dataset.loading==='true'||button.disabled)return;
const label=button.querySelector('span');
const originalLabel=label.textContent;
button.dataset.loading='true';
button.disabled=true;
button.setAttribute('aria-busy','true');
label.textContent='Adding…';
try{
const response=await fetch(categoryRoot+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.description||'Please try again.');}
const cart=await fetch(categoryRoot+'cart.js',{headers:{Accept:'application/json'}}).then(result=>result.json());
document.querySelectorAll('.rv-actions a[href$="/cart"] span').forEach(count=>{count.textContent=cart.item_count;});
label.textContent='Added ✓';
showCategoryCartToast('Added to your bag ✓');
}catch(error){
label.textContent='Try again';
showCategoryCartToast(error.message||'Could not add this item.',true);
}finally{
button.dataset.loading='false';
button.removeAttribute('aria-busy');
button.disabled=false;
setTimeout(()=>{label.textContent=originalLabel;},1800);
}
},true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranivaa-collection"] && !Shopify.designMode) return;
  try {
    
const arrangeCollectionHearts=(scope=document)=>{
scope.querySelectorAll('.rv-collection .rv-product-card').forEach(card=>{
if(card.dataset.heartReady)return;
card.dataset.heartReady='true';
const slot=card.querySelector('.rv-card-heart');
if(!slot)return;
const place=()=>{
const widget=card.querySelector('.Vtl-CollectionCardWidget');
if(!widget)return;
if(!slot.contains(widget))slot.appendChild(widget);
const control=widget.querySelector('.Vtl-WishlistButton__AddToWishlist');
if(control&&!control.hasAttribute('role')){
control.setAttribute('role','button');control.tabIndex=0;
control.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();control.click();}});
}
};
place();new MutationObserver(place).observe(card,{childList:true,subtree:true});
});
};
arrangeCollectionHearts();
document.addEventListener('shopify:section:load',event=>arrangeCollectionHearts(event.target));

const initializeCollectionLoadMore=(scope=document)=>{
scope.querySelectorAll('.rv-collection').forEach(collectionSection=>{
if(collectionSection.dataset.loadMoreReady)return;
const grid=collectionSection.querySelector('.rv-product-grid');
const pagination=collectionSection.querySelector('.rv-pagination');
const more=pagination?.querySelector('[data-rv-view-more]');
if(!grid||!pagination||!more)return;
collectionSection.dataset.loadMoreReady='true';
const firstNextUrl=more.href;
let busy=false,less;
const collapse=()=>{
grid.querySelectorAll('[data-rv-loaded-product]').forEach(card=>card.remove());
more.href=firstNextUrl;more.hidden=false;more.textContent='View more →';
less?.remove();less=null;
grid.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'end'});
};
const ensureLess=()=>{
if(less)return;
less=document.createElement('button');less.type='button';less.className='rv-pagination__link';less.textContent='← View less';
less.addEventListener('click',collapse);pagination.prepend(less);
};
more.addEventListener('click',async event=>{
event.preventDefault();if(busy)return;
busy=true;more.setAttribute('aria-disabled','true');more.textContent='Loading…';
try{
const response=await fetch(more.href,{headers:{'X-Requested-With':'XMLHttpRequest'}});
if(!response.ok)throw new Error('Unable to load more products');
const page=new DOMParser().parseFromString(await response.text(),'text/html');
const cards=[...page.querySelectorAll('.rv-product-grid > .rv-product-card')];
if(!cards.length)throw new Error('No additional products found');
cards.forEach(card=>{card.dataset.rvLoadedProduct='true';grid.appendChild(card);});
arrangeCollectionHearts(grid);ensureLess();
const next=page.querySelector('.rv-pagination [data-rv-view-more]');
if(next){more.href=next.href;more.textContent='View more →';}else{more.hidden=true;more.textContent='View more →';}
}catch(error){window.location.assign(more.href);return;}
finally{busy=false;more.removeAttribute('aria-disabled');}
});
});
};
initializeCollectionLoadMore();
document.addEventListener('shopify:section:load',event=>initializeCollectionLoadMore(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranivaa-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.rv-category-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.rv-category-menu[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranivaa-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ranivaa-hero')) {
    customElements.define('ranivaa-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-rv-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-rv-dot]'));
        this.current = 0;
        this.delay = Number(this.dataset.delay) || 5000;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.rvDot), true)));
        this.querySelector('[data-rv-previous]')?.addEventListener('click', () => this.show(this.current - 1, true));
        this.querySelector('[data-rv-next]')?.addEventListener('click', () => this.show(this.current + 1, true));
        this.pauseButton = this.querySelector('[data-rv-pause]');
        this.pauseButton?.addEventListener('click', () => this.togglePause());
        this.addEventListener('pointerenter', () => { this.hovered = true; this.stop(); });
        this.addEventListener('pointerleave', () => { this.hovered = false; this.start(); });
        this.addEventListener('focusin', () => { this.focused = true; this.stop(); });
        this.addEventListener('focusout', () => { window.setTimeout(() => { this.focused = this.contains(document.activeElement); this.start(); }, 0); });
        this.addEventListener('touchstart', (event) => { this.touchStart = event.changedTouches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].clientX - this.touchStart;
          if (Math.abs(distance) > 45) this.show(distance < 0 ? this.current + 1 : this.current - 1, true);
        }, { passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const selected = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (selected >= 0) this.show(selected, false);
        });
        this.show(0, false);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(index, restart) {
        if (!this.slides.length) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.current;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (restart) this.start();
      }

      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.focused || this.reducedMotion) return;
        this.timer = window.setInterval(() => this.show(this.current + 1, false), this.delay);
      }

      stop() {
        window.clearInterval(this.timer);
      }

      togglePause() {
        this.paused = !this.paused;
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
        if (this.paused) this.stop();
        else this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranivaa-moments"] && !Shopify.designMode) return;
  try {
    
function initRanivaaMoments(root=document){
const sections=[...(root.matches?.('[data-rv-moments]')?[root]:[]),...root.querySelectorAll('[data-rv-moments]')];
sections.forEach(section=>{
if(section.dataset.momentsReady)return;
section.dataset.momentsReady='true';
const tabs=[...section.querySelectorAll('[role="tab"]')],panels=[...section.querySelectorAll('[role="tabpanel"]')],pause=section.querySelector('[data-moments-pause]');
let current=0,timer,visible=false,paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
function sync(){pause.textContent=paused?'Play slideshow':'Pause slideshow';pause.setAttribute('aria-pressed',String(paused))}
function stop(){clearTimeout(timer)}
function schedule(){stop();if(!paused&&visible&&!document.hidden&&tabs.length>1)timer=setTimeout(()=>{select((current+1)%tabs.length);schedule()},6000)}
function select(i,focus=false){current=i;tabs.forEach((tab,n)=>{tab.setAttribute('aria-selected',String(n===i));tab.tabIndex=n===i?0:-1;panels[n].hidden=n!==i});const tab=tabs[i],bar=tab.parentElement;bar.scrollTo({left:Math.max(0,tab.offsetLeft-bar.offsetLeft-(bar.clientWidth-tab.offsetWidth)/2),behavior:'auto'});if(focus)tab.focus()}
tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>{select(i);schedule()});tab.addEventListener('keydown',event=>{let n=i;if(event.key==='ArrowRight')n=(i+1)%tabs.length;else if(event.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;else if(event.key==='Home')n=0;else if(event.key==='End')n=tabs.length-1;else return;event.preventDefault();select(n,true);schedule()})});
pause.addEventListener('click',()=>{paused=!paused;sync();schedule()});
section.addEventListener('pointerenter',stop);section.addEventListener('pointerleave',schedule);
const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule()},{threshold:.15});observer.observe(section);
const onVisibility=()=>schedule();document.addEventListener('visibilitychange',onVisibility);
section.addEventListener('shopify:block:select',event=>{const i=panels.indexOf(event.target);if(i>=0){select(i);paused=true;sync();stop()}});
const unload=event=>{if(event.target.contains(section)){stop();observer.disconnect();document.removeEventListener('visibilitychange',onVisibility);document.removeEventListener('shopify:section:unload',unload)}};document.addEventListener('shopify:section:unload',unload);
select(0);sync();schedule();
});
}
initRanivaaMoments();document.addEventListener('shopify:section:load',event=>initRanivaaMoments(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranivaa-necklace-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ranivaa-necklace-showcase')) {
    customElements.define('ranivaa-necklace-showcase', class extends HTMLElement {
      connectedCallback() {
        this.pieces = [...this.querySelectorAll('[data-piece]')];
        this.details = [...this.querySelectorAll('[data-details]')];
        this.index = 0;
        this.paused = false;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.editing = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.pauseButton = this.querySelector('[data-pause]');
        this.querySelector('.rv-necklaces__controls').hidden = this.pieces.length < 2;
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1, true), options);
        this.pauseButton.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { this.updatePause(); this.schedule(); }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.pieces.findIndex(piece => piece.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.editing = true; this.show(index, true); }
        }, options);
        document.addEventListener('shopify:block:deselect', () => { this.editing = false; this.schedule(); }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: .15 });
        this.observer.observe(this);
        this.show(0);
        this.updatePause();
      }
      updatePause() {
        this.pauseButton.hidden = this.motion.matches;
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
      }
      show(index, announce = false) {
        this.index = (index + this.pieces.length) % this.pieces.length;
        this.pieces.forEach((piece, i) => {
          const requeue = piece.classList.contains('is-previous') && i === (this.index + 1) % this.pieces.length;
          if (requeue) piece.classList.add('is-resetting');
          piece.classList.toggle('is-current', i === this.index);
          piece.classList.toggle('is-next', this.pieces.length > 1 && i === (this.index + 1) % this.pieces.length);
          piece.classList.toggle('is-previous', i !== this.index && i !== (this.index + 1) % this.pieces.length);
          this.details[i].hidden = i !== this.index;
          if (requeue) { piece.getBoundingClientRect(); piece.classList.remove('is-resetting'); }
        });
        this.querySelector('[data-position]').textContent = `${this.index + 1} / ${this.pieces.length}`;
        if (announce) this.querySelector('[data-announcement]').textContent = this.details[this.index].querySelector('h3').textContent;
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.pieces.length < 2 || !this.visible || this.paused || this.hovered || this.focused || this.editing || this.motion.matches || document.hidden) return;
        this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.delay) || 5000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranivaa-product"] && !Shopify.designMode) return;
  try {
    
  const titleCaseUnits = new Set([
    'mm',
    'cm',
    'm',
    'km',
    'mg',
    'g',
    'kg',
    'ml',
    'l',
    'oz',
    'ct',
    'in',
    'inch',
    'inches',
    'karat',
    'karats'
  ]);

  const titleCaseText = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node = walker.nextNode();

    while (node) {
      nodes.push(node);
      node = walker.nextNode();
    }

    nodes.forEach((textNode) => {
      const parent = textNode.parentElement;

      if (!parent || parent.closest('a, code, pre, kbd, samp, script, style, time, data')) return;

      textNode.nodeValue = textNode.nodeValue.replace(/\S+/g, (token) => {
        const core = token.replace(/^[^A-Za-z0-9]+|[^A-Za-z0-9]+$/g, '');
        const normalized = core.toLowerCase();

        if (
          !core ||
          core.includes('@') ||
          core.includes('://') ||
          core.includes('/') ||
          core.includes('\\') ||
          core.includes('_') ||
          /\d/.test(core) ||
          titleCaseUnits.has(normalized) ||
          /^[A-Z]{2,4}$/.test(core) ||
          /[A-Z]/.test(core.slice(1))
        ) {
          return token;
        }

        return token.replace(/[A-Za-z]+(?:[’'][A-Za-z]+)?/g, (word) => {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        });
      });
    });
  };

  const applyRanivaaTitleCase = (scope = document) => {
    scope.querySelectorAll('.rv-product .rv-title-case').forEach(titleCaseText);
  };

  applyRanivaaTitleCase();
  document.addEventListener('shopify:section:load', (event) => applyRanivaaTitleCase(event.target));

  const arrangeRanivaaWishlist = (scope = document) => {
    scope.querySelectorAll('.rv-product__details').forEach((details) => {
      if (details.dataset.wishlistLayoutReady) return;
      details.dataset.wishlistLayoutReady = 'true';
      const slot = details.querySelector('.rv-product__wishlist-slot');
      if (!slot) return;
      const placeWishlist = () => {
        const productRoot = details.closest('.rv-product') || details;
        const wishlist = productRoot.querySelector('.Vtl-WishlistButtonWrapper, .Vtl-WishlistCustomButtonWrapper:not(.Vtl-CollectionCardWidget)');
        if (!wishlist) return;
        if (!slot.contains(wishlist)) {
          let wrapper = wishlist;
          while (wrapper.parentElement && wrapper.parentElement !== details && wrapper.parentElement !== slot && wrapper.parentElement.className.includes('Vtl-')) {
            wrapper = wrapper.parentElement;
          }
          slot.appendChild(wrapper);
        }
        const control = wishlist.querySelector('.Vtl-WishlistButton__AddToWishlist');
        if (control && !control.dataset.rvKeyboard) {
          control.dataset.rvKeyboard = 'true';
          control.setAttribute('role', 'button');
          control.setAttribute('tabindex', '0');
          control.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              control.click();
            }
          });
        }
      };
      placeWishlist();
      const observer = new MutationObserver(placeWishlist);
      observer.observe(details.closest('.rv-product') || details, { childList: true, subtree: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(details)) observer.disconnect();
      });
    });
  };
  arrangeRanivaaWishlist();
  document.addEventListener('shopify:section:load', (event) => arrangeRanivaaWishlist(event.target));


  const setupRanivaaGallery = (scope = document) => {
    scope.querySelectorAll('.rv-gallery').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const slides = [...gallery.querySelectorAll('.rv-gallery__slide')];
      if (slides.length < 2) return;
      let current = 0;
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        gallery.querySelector('.rv-gallery__status').textContent = (current + 1) + ' / ' + slides.length;
      };
      gallery.addEventListener('rv:variant-image', (event) => {
        const index = slides.findIndex(slide => slide.dataset.imageId === event.detail);
        if (index >= 0) show(index);
      });
      gallery.querySelector('.rv-gallery__arrow--prev').addEventListener('click', () => show(current - 1));
      gallery.querySelector('.rv-gallery__arrow--next').addEventListener('click', () => show(current + 1));
      let touchStartX = 0, touchStartY = 0, trackingSwipe = false;
      gallery.addEventListener('touchstart', (event) => {
        trackingSwipe = event.touches.length === 1;
        if (!trackingSwipe) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });
      gallery.addEventListener('touchmove', (event) => {
        if (event.touches.length !== 1) trackingSwipe = false;
      }, { passive: true });
      gallery.addEventListener('touchend', (event) => {
        if (!trackingSwipe || event.changedTouches.length !== 1) return;
        trackingSwipe = false;
        const distanceX = event.changedTouches[0].clientX - touchStartX;
        const distanceY = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(distanceX) < 45 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
        show(current + (distanceX < 0 ? 1 : -1));
      }, { passive: true });
      gallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          show(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    });
  };
  setupRanivaaGallery();
  document.addEventListener('shopify:section:load', (event) => setupRanivaaGallery(event.target));


  const setupRanivaaVariants = (scope = document) => {
    scope.querySelectorAll('.rv-product__simple-form').forEach(form => {
      if (form.dataset.variantReady) return;
      form.dataset.variantReady = 'true';
      const root = form.closest('.rv-product');
      const update = (input, updateUrl) => {
        if (!input) return;
        const price = root.querySelector('.rv-product__price');
        price.replaceChildren();
        if (input.dataset.compare) {
          const compare = document.createElement('s');
          compare.textContent = input.dataset.compare;
          price.appendChild(compare);
        }
        const selling = document.createElement('span');
        selling.textContent = input.dataset.price;
        price.appendChild(selling);
        const gallery = root.querySelector('.rv-gallery');
        if (input.dataset.image && gallery) gallery.dispatchEvent(new CustomEvent('rv:variant-image', {detail:input.dataset.image}));
        if (updateUrl) {
          const url = new URL(location.href);
          url.searchParams.set('variant', input.value);
          history.replaceState(history.state, '', url);
        }
      };
      form.addEventListener('change', event => {
        if (event.target.matches('[data-rv-variant]')) update(event.target, true);
      });
      update(form.querySelector('[data-rv-variant]:checked'), false);
    });
  };
  setupRanivaaVariants();
  document.addEventListener('shopify:section:load', event => setupRanivaaVariants(event.target));

  const loadRanivaaRelated = (scope = document) => {
    scope.querySelectorAll('.rv-related[data-url]').forEach((section) => {
      if (section.dataset.loaded) return;
      section.dataset.loaded = 'true';
      fetch(section.dataset.url)
        .then((response) => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const grid = html.querySelector('.rv-related__grid');
          if (grid && grid.querySelector('.rv-related__card')) section.querySelector('.rv-related__grid').replaceWith(grid);
        })
        .catch(() => {});
    });
  };
  loadRanivaaRelated();
  document.addEventListener('shopify:section:load', (event) => loadRanivaaRelated(event.target));


  const setupRanivaaImageZoom = (scope = document) => {
    if (window.matchMedia('(max-width: 749px)').matches) return;
    scope.querySelectorAll('.rv-gallery').forEach((gallery) => {
      if (gallery.dataset.zoomReady) return;
      gallery.dataset.zoomReady = 'true';
      const images = [...gallery.querySelectorAll('.rv-gallery__slide img')];
      if (!images.length) return;
      const dialog = document.createElement('dialog');
      dialog.className = 'rv-image-zoom';
      dialog.setAttribute('aria-label', 'Product image zoom viewer');
      dialog.innerHTML = '<div class="rv-image-zoom__bar"><button type="button" data-zoom-out aria-label="Zoom out">−</button><span class="rv-image-zoom__level" aria-live="polite">100%</span><button type="button" data-zoom-in aria-label="Zoom in">+</button><button type="button" data-zoom-reset>Reset</button><button type="button" class="rv-image-zoom__close" data-zoom-close>Close</button></div><div class="rv-image-zoom__stage"><img class="rv-image-zoom__image" alt=""></div><p class="rv-image-zoom__hint">Pinch to zoom · drag to move</p>';
      document.body.appendChild(dialog);
      const stage = dialog.querySelector('.rv-image-zoom__stage');
      const zoomedImage = dialog.querySelector('.rv-image-zoom__image');
      const level = dialog.querySelector('.rv-image-zoom__level');
      const zoomIn = dialog.querySelector('[data-zoom-in]');
      const zoomOut = dialog.querySelector('[data-zoom-out]');
      let zoom = 1, baseWidth = 0, baseHeight = 0;
      const draw = (center = true) => {
        zoomedImage.style.width = Math.round(baseWidth * zoom) + 'px';
        zoomedImage.style.height = Math.round(baseHeight * zoom) + 'px';
        level.textContent = Math.round(zoom * 100) + '%';
        zoomOut.disabled = zoom <= 1; zoomIn.disabled = zoom >= 3;
        stage.dataset.zoomed = zoom > 1 ? 'true' : 'false';
        if (center) requestAnimationFrame(() => stage.scrollTo({ left: (stage.scrollWidth - stage.clientWidth) / 2, top: (stage.scrollHeight - stage.clientHeight) / 2 }));
      };
      const measure = () => {
        const availableWidth = Math.max(1, stage.clientWidth - 40);
        const availableHeight = Math.max(1, stage.clientHeight - 40);
        const fit = Math.min(availableWidth / zoomedImage.naturalWidth, availableHeight / zoomedImage.naturalHeight);
        baseWidth = zoomedImage.naturalWidth * fit; baseHeight = zoomedImage.naturalHeight * fit; draw();
      };
      const setZoom = (value, center = true) => { zoom = Math.min(3, Math.max(1, value)); draw(center); };
      const setZoomAt = (value, clientX, clientY) => {
        const previousZoom = zoom;
        const bounds = stage.getBoundingClientRect();
        const offsetX = clientX - bounds.left;
        const offsetY = clientY - bounds.top;
        const contentX = stage.scrollLeft + offsetX;
        const contentY = stage.scrollTop + offsetY;
        zoom = Math.min(3, Math.max(1, value));
        draw(false);
        requestAnimationFrame(() => {
          const ratio = zoom / previousZoom;
          stage.scrollLeft = contentX * ratio - offsetX;
          stage.scrollTop = contentY * ratio - offsetY;
        });
      };
      const open = (image) => {
        zoom = 1; zoomedImage.alt = image.alt || 'Product photo'; zoomedImage.src = image.currentSrc || image.src; dialog.showModal();
        if (zoomedImage.complete) requestAnimationFrame(measure);
      };
      zoomedImage.addEventListener('load', measure);
      zoomIn.addEventListener('click', () => setZoom(zoom + .5));
      zoomOut.addEventListener('click', () => setZoom(zoom - .5));
      dialog.querySelector('[data-zoom-reset]').addEventListener('click', () => setZoom(1));
      dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      const pointers = new Map();
      let pinchDistance = 0, pinchZoom = 1, lastTap = 0;
      stage.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch') return;
        event.preventDefault(); stage.setPointerCapture(event.pointerId);
        pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (pointers.size === 2) {
          const points = [...pointers.values()];
          pinchDistance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y); pinchZoom = zoom;
        } else if (zoom > 1) stage.dataset.dragging = 'true';
      });
      stage.addEventListener('pointermove', (event) => {
        const previous = pointers.get(event.pointerId); if (!previous) return;
        event.preventDefault(); pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (pointers.size === 2) {
          const points = [...pointers.values()];
          const distance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
          const centerX = (points[0].x + points[1].x) / 2, centerY = (points[0].y + points[1].y) / 2;
          if (pinchDistance) setZoomAt(pinchZoom * distance / pinchDistance, centerX, centerY);
        } else if (zoom > 1) {
          stage.scrollLeft -= event.clientX - previous.x; stage.scrollTop -= event.clientY - previous.y;
        }
      });
      const releasePointer = (event) => {
        if (!pointers.has(event.pointerId)) return; pointers.delete(event.pointerId);
        if (pointers.size < 2) pinchDistance = 0; if (!pointers.size) stage.dataset.dragging = 'false';
        if (event.pointerType === 'touch' && event.type === 'pointerup') {
          const now = Date.now(); if (now - lastTap < 300) setZoomAt(zoom > 1 ? 1 : 2, event.clientX, event.clientY); lastTap = now;
        }
      };
      stage.addEventListener('pointerup', releasePointer); stage.addEventListener('pointercancel', releasePointer);
      zoomedImage.addEventListener('dblclick', (event) => setZoomAt(zoom > 1 ? 1 : 2, event.clientX, event.clientY));
      images.forEach((image) => {
        image.tabIndex = 0; image.setAttribute('role', 'button'); image.setAttribute('aria-label', 'Open ' + (image.alt || 'product photo') + ' in zoom viewer');
        image.addEventListener('click', () => open(image));
        image.addEventListener('keydown', (event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(image); } });
      });
      document.addEventListener('shopify:section:unload', (event) => { if (event.target.contains(gallery)) dialog.remove(); }, { once: true });
    });
  };
  setupRanivaaImageZoom();
  document.addEventListener('shopify:section:load', (event) => setupRanivaaImageZoom(event.target));

  } catch(e) { console.error(e); }
})();
})();
